// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Home: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 53.1"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M49.2 24.5L25.8 1c-.2-.2-.6-.3-.9-.3-.2 0-.4.2-.5.3L.7 24.5c-.4.4-.4 1 0 1.4l.5.5c.2.2.4.3.7.3.3 0 .5-.1.7-.3L25 4.1l22.2 22.2c.4.4 1 .4 1.4 0l.5-.5c.4-.3.4-.9.1-1.3zm-4.7 2.3h-.8c-.6 0-1 .4-1 1v21.8h-10v-16c0-.6-.4-1-1-1H17.2c-.6 0-1 .4-1 1v16H7.3V27.8c0-.6-.4-1-1-1h-.8c-.6 0-1 .4-1 1v23.6c0 .6.4 1 1 1h12.4c.6 0 1-.4 1-1v-16h11v16c0 .6.4 1 1 1h13.6c.6 0 1-.4 1-1V27.8c0-.5-.4-1-1-1z"/></svg>;
};

export default React.memo(Home);
